import isEqual from 'date-fns/isEqual';
import React, { useRef } from 'react';
import * as Styled from './styled';
import useDraggableScroll from 'use-draggable-scroll';
import { useTranslation } from 'react-i18next';
import { isLinesUsedInDates } from '../../../helpers/experiments';

const CalendarTimes = ({ times, selectedDate, onSelectDate }) => {
  const { t } = useTranslation();
  const ref = useRef(null);
  const { onMouseDown } = useDraggableScroll(ref);

  return (
    <Styled.TimesContainer>
      <Styled.TimesTitle>{t('selectTime')}</Styled.TimesTitle>
      <Styled.TimesItems ref={ref} onMouseDown={onMouseDown}>
        {times.map((item) => {
          const handleSelect = () => onSelectDate(item);

          return (
            <Styled.TimeItem key={item.date}>
              <Styled.Time
                onClick={handleSelect}
                isSelected={isEqual(item.date, selectedDate)}
                isLines={isLinesUsedInDates()}
              >
                {item.has_tickets ? <Styled.TimeHasTickets /> : <Styled.TimeNoTickets />}
                {item.time}
              </Styled.Time>
            </Styled.TimeItem>
          );
        })}
      </Styled.TimesItems>
    </Styled.TimesContainer>
  );
};

export default CalendarTimes;
